import { ReactNode } from 'react';

import { DropdownMenuPlacement } from 'components/Dropdown/types/DropdownMenuPlacement';

import { DropdownMenuHolder } from './DropdownMenu.styled';

type Props = {
  width?: number;
  children: ReactNode;
  qaId?: string;
  placement?: DropdownMenuPlacement;
  mobilePlacement?: DropdownMenuPlacement;
};

export function DropdownMenu({
  width,
  children,
  qaId,
  placement = 'bottom-left',
  mobilePlacement = 'bottom-left',
}: Props) {
  return (
    <DropdownMenuHolder
      style={{ width }}
      data-qa-id={qaId}
      $placement={placement}
      $mobilePlacement={mobilePlacement}
    >
      {children}
    </DropdownMenuHolder>
  );
}
